import React from "react"

import { AppAntSwitch } from "@components"
import { dailyPrice } from "@signals"


export default function AppCommonFiltersDailyPriceToggleButton() {
	return <AppAntSwitch
		checked={dailyPrice.value}
		onChange={e => dailyPrice.value = e.target.checked}
		falseText="Total price"
		trueText="Daily"
	/>
}